import { memo } from 'react';
import FJTextToImageModels from '../view/FJTextToImageModels';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import FJActionTextToImage from '../../../../redux/action/FJActionTextToImage';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJTextToImageModelsContainer = memo(function FJTextToImageModelsContainer() {
    useLocalStore();
    const dispatch = useDispatch();
    const curModel = useSelector(state => state.textToImage.curModel);

    const handleChangeModel = useCallback(
        value => {
            dispatch(FJActionTextToImage.changeModelAction(value.value));
        },
        [dispatch],
    );

    return <FJTextToImageModels curModel={curModel} onChange={handleChangeModel} />;
});

export default FJTextToImageModelsContainer;
